import SelectTimeSeriesData from './select-time-series-data';
import SelectSingleData from './select-single-data';
import SelectTrendData from './select-trend-data';

export const dataTypes = [
	{
		title: 'Single Data Set',
		description: 'Report on a single data set such as your sales filterable for a period of time.',
		value: 'single',
	},
	{
		title: 'Time Series',
		description: 'Report on a single data indexed over a period of time such as daily revenue for your sales',
		value: 'time_series',
	},
	{
		title: 'Trends & Summaries',
		description: 'Report on a predefined trend for a fixed period of time.',
		value: 'trends',
	},
];

export const dataTypeComponentMap = {
	time_series: SelectTimeSeriesData,
	single: SelectSingleData,
	trends: SelectTrendData,
};
